













































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { vxm } from '@/store.vuex';
import EditEditor from './EditEditor.vue';
import WlAvatar from '@/components/Commons/WlAvatar.vue';
import ReportAction from './ReportAction.vue';
@Component({
  components: {
    EditEditor,
    WlAvatar,
    ReportAction,
  },
})
export default class PostAction extends Vue {
  private deletePostDetail: any;
  private deletePostIds: any = [];
  private editFlag: boolean = false;

  $wlToastr: any;
  @Prop() post;
  @Prop({ default: false }) isPostDetailsPage;

  async deletePost(postId) {
    this.deletePostDetail = {};
    this.deletePostIds.push(postId);
    this.deletePostDetail.postId = this.deletePostIds;
    this.deletePostDetail.postStatus = 3;
    this.deletePostDetail.updateReason = '';
    const resp = await vxm.forum.deletePost(this.deletePostDetail);
    if (resp.success) {
      vxm.users.Rudderstack.trackEvent("Forum Post Deleted", {
      forumPostId : postId
        });
      this.$wlToastr('success', resp.successMessage, '');
      this.isPostDetailsPage && this.$router.push({ name: 'Forum' });
    } else {
      this.$wlToastr('error', resp.errorMessage, '');
    }
  }
  get fullName() {
    return `${this.post.candidateInfo.firstName} ${
      this.post.candidateInfo.lastName
    }`;
  }
  get currentUser() {
    return vxm.users.myUserProfile;
  }
  findPostId(postId) {
    this.editFlag = true;
  }

  get appTheme() {
    return vxm.utility.AppTheme;
  }
}
